import { render, staticRenderFns } from "./Opacity.vue?vue&type=template&id=652c22f4&"
import script from "./Opacity.vue?vue&type=script&lang=js&"
export * from "./Opacity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports